<template>
  <v-sheet elevation="2" class="px-12 py-8 rounded white">
    <div class="mb-6">
      <p class="h6 pa-0 mb-0">
        {{ $t('profile_settings.skill_other') }}
      </p>
      <p class="mt-2 pa-0 grey--text text--darken-2">
        {{ $t('profile_settings.skills_subtitle') }}
      </p>
    </div>
    <SkillsEditor
      autofocus
      data-testid="profileSettings-skillsEditor"
      :skills="skills"
      :isLoading="isLoading"
      @update="onUpdate"
    />
  </v-sheet>
</template>
<script>
import SkillsEditor from '@/components/Skills/SkillsEditor.vue'

export default {
  name: 'Skills',

  components: {
    SkillsEditor,
  },

  props: {
    skills: {
      type: Array,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },

  methods: {
    onUpdate(payload) {
      this.$emit('update', payload)
    },
  },
}
</script>
